import { observable } from 'mobx';
import {FormInviteModel} from '../../../components/form-invite';
import {createInviteForm} from '../../../lib/form';
import {InviteSchema} from '../../../types/schema';
import {PageAccountInvitesModel} from '../../../components/page-account-invites';
import {Coupon} from '../../../components/user/coupon';

export class AccountInvitesPageModel implements PageAccountInvitesModel {
  @observable
  loading: boolean = false;

  @observable
  invites: Array<InviteSchema> = [];

  @observable
  form: FormInviteModel = createInviteForm();

  @observable
  title: string = null;

  @observable
  content: any = null;

  @observable
  cta: string = null;

  @observable
  referralURL: string = '';

  @observable
  referralTitle: string = '';
}